import React from 'react';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {

    const downloadPdfDocument = () => {
        const input = document.getElementById(rootElementId);
        html2canvas(input)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF("p", "pt", "a4");
                pdf.addImage(imgData, 'JPEG', 0, 0);
                pdf.save(`${downloadFileName}.pdf`);
            })
    }
    const handleDownload = async () => {
        const pdf = new jsPDF("p", "mm", "a4");
        const pages = document.querySelectorAll(".page");
        /* const pages = document.getElementById(rootElementId); */
        for (const [index, page] of pages.entries()) {
            const canvas = await html2canvas(page, { scale: 3 });

            const paddingTop = 50;
            const paddingRight = 50;
            const paddingBottom = 50;
            const paddingLeft = 50;

            const canvasWidth = canvas.width + paddingLeft + paddingRight;
            const canvasHeight = canvas.height + paddingTop + paddingBottom;

            const newCanvas = document.createElement("canvas");
            newCanvas.width = canvasWidth;
            newCanvas.height = canvasHeight;
            const ctx = newCanvas.getContext("2d");

            if (ctx) {
                ctx.fillStyle = "#ffffff"; // Background color
                ctx.fillRect(0, 0, canvasWidth, canvasHeight);
                ctx.drawImage(canvas, paddingLeft, paddingTop);
            }

            const imgData = newCanvas.toDataURL("image/png");
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

            if (index < pages.length - 1) {
                pdf.addPage();
            }
        }

        pdf.save("content.pdf");
    };

    return <>{/* <div className='page' id="page">hello</div> */}<button className="btn btn-dark" onClick={downloadPdfDocument}><i className='fa fa-download'></i> Download</button> {/* <button className="btn btn-dark" onClick={handleDownload}><i className='fa fa-download'></i> print pdf</button> */}</>

}

export default GenericPdfDownloader;